function Bahrain({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_596)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 0C12.789 0 9.79949 0.946563 7.29374 2.57488L11.4087 5.33294L6.26086 7.99956L11.4087 10.6662L6.26086 13.3328L11.4087 15.9991L6.26086 18.6657L11.4087 21.3323L6.26086 23.9991L11.4087 26.6658L7.29324 29.4247C9.79911 31.0533 12.7888 32 16 32C24.8365 32 32 24.8365 32 16C32 7.1635 24.8365 0 16 0V0Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Bahrain;
